import { render, staticRenderFns } from "./PrintProductBarcode.vue?vue&type=template&id=2b0c4cc2"
import script from "./PrintProductBarcode.vue?vue&type=script&lang=js"
export * from "./PrintProductBarcode.vue?vue&type=script&lang=js"
import style0 from "./PrintProductBarcode.vue?vue&type=style&index=0&id=2b0c4cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports